<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách vật tư theo trạng thái</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <Select2
              v-model="search.categoryId"
              :options="optionType"
              placeholder="Tên vật tư"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="warehouseSearch.region"
              :options="optionRegion"
              placeholder="Vùng"
            ></Select2>
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="warehouseSearch.level"
              :options="optionLevel"
              :settings="{ placeholder: 'Cấp kho' }"
            ></select2-multiple-control>
          </div>
          <div class="form-group">
            <Select2
              v-model="warehouseSearch.inventories"
              :options="optionInventory"
              placeholder="Tên kho"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.managerId"
              :options="optionStaff"
              placeholder="Người quản lý"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.keeperId"
              :options="optionStaff"
              placeholder="Thủ kho"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="
                optionStatus.filter(
                  s => !['EXPORTED', 'LENT', 'LENT_WARRANTY', 'EXPORT_RENT'].includes(s.id)
                )
              "
              placeholder="Trạng thái"
            ></Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: {{ pagination.total }}
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataDevice"
              :fields="filterTable"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(keeper)="data">
                <div v-if="data.item.keeper">
                  {{ data.item.keeper.name }} <br />
                  <span class="text-primary">{{ data.item.keeper.email }}</span>
                </div>
                <div v-else></div>
              </template>
              <template #cell(manager)="data">
                <div v-if="data.item.manager">
                  {{ data.item.manager.name }}
                </div>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.deviceStatus ? data.item.deviceStatus : '']">
                  {{ data.item.deviceStatus | transformData(optionStatus) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown id="dropdown-1" class="m-md-2" variant="outline-light">
                  <b-dropdown-item @click="onRowSelected(data.item)"> Chi tiết </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          class="fl-right col-sm-4"
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import Config from '@/thirdParty/config'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'categoryName', label: 'Tên vật tư' },
    { key: 'quantity', label: 'Số lượng' },
    { key: 'inventoryName', label: 'Tên kho' },
    { key: 'manager', label: 'Người quản lý' },
    { key: 'keeper', label: 'Thủ kho' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'list-material-status',
    mixins: [prepareQueryParamsMixin],
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
      selectAll: {
        get: function () {
          return this.dataDevice ? this.selected.length === this.dataDevice.length : false
        },
        set: function (value) {
          var selected = []
          if (value) {
            this.dataDevice.forEach(function (item) {
              selected.push(item)
            })
          }
          this.selected = selected
        },
      },
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
      'warehouseSearch.region': function () {
        this.testing()
      },
      'warehouseSearch.level': function () {
        if (this.warehouseSearch.level.length === 0) {
          delete this.warehouseSearch.level
        }
        this.testing()
      },
    },
    data() {
      return {
        Config,
        loading: false,
        showLoading: false,
        fieldsTable,
        filterTable: fieldsTable,
        optionLevel: Config.levelWarehouse,
        optionStatus: Config.statusDevices,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        optionStaff: [],
        optionRegion: [],
        optionInventory: [],
        copy: [],
        warehouseSearch: {},
        dataDevice: [],
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        selected: [],
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        optionType: [],
      }
    },
    created() {
      this.getListStaff()
      this.getListRegion()
      this.getListInventory()
      this.fetchData()
      this.typeDeviceConfig()
    },

    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    methods: {
      async testing() {
        try {
          this.showLoading = true
          this.optionInventory = this.copy
          if (this.checkSelect(this.warehouseSearch.region)) {
            await this.listStaffRegion([this.warehouseSearch.region])
            this.optionInventory = this.optionInventory.filter(
              el => el.regions !== null && el.regions.includes(this.warehouseSearch.region)
            )
          } else {
            delete this.warehouseSearch.region
          }
          if (this.checkSelect(this.warehouseSearch.level)) {
            this.optionInventory = this.optionInventory.filter(
              el => el.level !== null && this.warehouseSearch.level.includes(el.level)
            )
          } else {
            delete this.warehouseSearch.level
          }
        } catch (error) {
        } finally {
          this.showLoading = false
        }
      },
      onRowSelected(item) {
        window.open(`/material/status/${item.id}`, '_blank')
      },
      async getListStaff() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.success) {
            this.optionStaff = data.data.map(e => {
              return {
                id: e.userId,
                text: `${e.userName} - ${e.name}`,
              }
            })
            this.optionStaff.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async listStaffRegion(regionList) {
        try {
          const data = await StaffService.getListLowerGrade({
            userId: this.dataUser.userId,
            region: regionList,
          })
          this.optionStaff = data.data.map(e => {
            return { id: e.id, text: `${e.name} - ${e.userName}` }
          })
        } catch (e) {
          console.error(e)
        }
      },
      async getListRegion() {
        try {
          const data = await StaffService.getRegions()
          if (data.success) {
            this.optionRegion = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.optionRegion.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getListInventory() {
        try {
          const data = await DeviceService.infoWarehouse()
          if (data.success) {
            const body = data.data.map(e => {
              return {
                ...e,
                text: e.name,
              }
            })
            body.unshift({ id: '0', text: 'Tất cả', regions: [], level: '' })
            this.optionInventory = [...body]
            this.copy = [...body]
          }
        } catch (error) {
          console.log(error)
        }
      },

      checkSelect(sel) {
        if (sel !== '0' && sel !== undefined) {
          return true
        } else {
          return false
        }
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        await this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.warehouseSearch = {}
        this.selected = []
        this.optionInventory = this.copy
        await this.fetchData()
      },

      async fetchData() {
        try {
          this.loading = true
          if (this.search.categoryId === '0') delete this.search.categoryId
          if (this.search.managerId === '0') delete this.search.managerId
          if (this.search.keeperId === '0') delete this.search.keeperId
          if (this.checkSelect(this.warehouseSearch.inventories)) {
            this.search.inventoryIds = [this.warehouseSearch.inventories]
          } else {
            if (
              this.warehouseSearch.region !== undefined ||
              this.warehouseSearch.level !== undefined
            ) {
              const idInventory = this.optionInventory.map(e => e.id)
              this.search.inventoryIds = idInventory
            } else {
              delete this.search.inventoryIds
            }
          }
          await this.listDeviceStatus()
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async listDeviceStatus() {
        const data = await DeviceService.listDeviceStatus(this.search)
        if (data.success) {
          this.dataDevice = data.data.normalDeviceStatuses
          this.pagination.total = data.data.count ? data.data.count : 0
        }
      },
      async typeDeviceConfig() {
        try {
          const params = {
            kind: 'NORMAL',
          }
          const data = await DeviceService.deviceKindNomal(params)
          if (data.success) {
            this.optionType = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.optionType.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // async exportExcel () {
      //   try {
      //     this.showLoading = true
      //     const req = { ...this.search }
      //     delete req.page
      //     delete req.limit
      //     if (this.dataDevice.length > 0) {
      //       const data = await DeviceService.exportDevice(req)
      //       if (data.success) {
      //         this.notiModal = true
      //         this.iconNoti = require('@/assets/img/noti-success2.svg')
      //         this.msgNoti = 'Dữ liệu sẽ được gửi đến email của bạn sau ít phút, vui lòng kiểm tra email cá nhân'
      //       } else {
      //         this.notiModal = true
      //         this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
      //         this.msgNoti = data.message
      //       }
      //     } else {
      //       this.notiModal = true
      //       this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
      //       this.msgNoti = 'Không có dữ liệu để xuất'
      //     }
      //   } catch (error) {
      //     console.log(error)
      //   } finally {
      //     this.showLoading = false
      //   }
      // }
    },
  }
</script>

<style>
  .time-placeholder,
  .text-search::placeholder {
    color: #999 !important;
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px !important;
  }
  .ACTIVE {
    color: #fff;
    background-color: #007bff;
  }
</style>
